import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import { Button } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';
import _400PegsNoticeModalComponent from './_400PegsNoticeModal';
import MissingCreditHeader from './MissingCreditHeader';
import InStoreReceipt from './InStoreReceipt';
import OnlineReceipt from './OnlineReceipt';
import { connect } from 'react-redux';
import { rewardsDuck } from '../../../ducks/rewards';
import LoadingAnimation from './LoadingAnimation';
import PegsAwardedModal from './PegsAwardedModal';
import LoadingErrorModal from './LoadingErrorModal';
import { PegsPreviouslyRewardedModal as PegsPreviouslyRewardedModalComponent } from './PegsPreviouslyRewardedModal';
import { ReceiptExpiredModal } from './ReceiptExpiredModal';
import { NoActiveAccountModal } from './NoActiveAccountModal';
import { ReceiptScanModal } from './ReceiptScanModal';
import { useFlags } from 'launchdarkly-react-client-sdk';
import ReceiptNotFoundModal from './ReceiptNotFoundModal';

var MissingCredit = function MissingCredit(props) {
  var _ReceiptScan400PegsNo, _ReceiptScanPegsAward, _ReceiptScanPegsPrevi, _ReceiptScanReceiptEx, _ReceiptScanLoyaltyAc, _Header$, _ReceiptScanReceiptSc, _ReceiptScanReceiptNo, _InStoreComponent$, _OnlineOrderComponent;

  var fields = props.fields,
      _props$setShowMissCre = props.setShowMissCreditInfo,
      setShowMissCreditInfo = _props$setShowMissCre === void 0 ? function () {
    return "";
  } : _props$setShowMissCre;
  var Header = fields.Header,
      ReceiptScan400PegsNoticeModal = fields.ReceiptScan400PegsNoticeModal,
      InStoreComponent = fields.InStoreComponent,
      OnlineOrderComponent = fields.OnlineOrderComponent,
      ReceiptScanPegsAwardedModal = fields.ReceiptScanPegsAwardedModal,
      ReceiptScanLoadingAnimation = fields.ReceiptScanLoadingAnimation,
      ReceiptScanPegsPreviouslyRewardedModal = fields.ReceiptScanPegsPreviouslyRewardedModal,
      ReceiptScanReceiptExpiredModal = fields.ReceiptScanReceiptExpiredModal,
      ReceiptScanLoyaltyAccountNotActiveModal = fields.ReceiptScanLoyaltyAccountNotActiveModal,
      ReceiptScanReceiptScanModal = fields.ReceiptScanReceiptScanModal,
      ReceiptScanReceiptNotFoundModal = fields.ReceiptScanReceiptNotFoundModal;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      show400PegsNoticeModal = _useState2[0],
      setShow400PegsNoticeModal = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      receiptScreens = _useState4[0],
      setReceiptScreens = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      showLoading = _useState6[0],
      setShowLoading = _useState6[1];

  var _useState7 = useState({
    show: false,
    pegs: 0
  }),
      _useState8 = _slicedToArray(_useState7, 2),
      showAwardedModal = _useState8[0],
      setShowAwardedModal = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      showLoadingErrorModal = _useState10[0],
      setShowLoadingErrorModal = _useState10[1];

  var _useState11 = useState(null),
      _useState12 = _slicedToArray(_useState11, 2),
      formikRef = _useState12[0],
      setFormikRef = _useState12[1];

  var _useState13 = useState(false),
      _useState14 = _slicedToArray(_useState13, 2),
      showPegsPreviouslyRewardedModal = _useState14[0],
      setShowPegsPreviouslyRewardedModal = _useState14[1];

  var _useState15 = useState(false),
      _useState16 = _slicedToArray(_useState15, 2),
      showReceiptExpiredModal = _useState16[0],
      setShowReceiptExpiredModal = _useState16[1];

  var _useState17 = useState(false),
      _useState18 = _slicedToArray(_useState17, 2),
      showNoActiveAccountModal = _useState18[0],
      setShowNoActiveAccountModal = _useState18[1];

  var _useState19 = useState(false),
      _useState20 = _slicedToArray(_useState19, 2),
      showReceiptScanModal = _useState20[0],
      setShowReceiptScanModal = _useState20[1];

  var _useState21 = useState(false),
      _useState22 = _slicedToArray(_useState21, 2),
      showReceiptNotFoundModal = _useState22[0],
      setShowReceiptNotFoundModal = _useState22[1];

  var _useState23 = useState('missingCredit'),
      _useState24 = _slicedToArray(_useState23, 2),
      screen = _useState24[0],
      setScreen = _useState24[1];

  var resetOrderNumberField = function resetOrderNumberField(formikRef) {
    var _formikRef$current;

    formikRef === null || formikRef === void 0 ? void 0 : formikRef.current.setFieldValue('orderNumber', '');
    formikRef === null || formikRef === void 0 ? void 0 : (_formikRef$current = formikRef.current) === null || _formikRef$current === void 0 ? void 0 : _formikRef$current.setTouched({
      orderNumber: false
    });
  };

  var handleSubmitOrderNumber = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(orderNumber, type) {
      var formikRef,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              formikRef = _args.length > 2 && _args[2] !== undefined ? _args[2] : null;
              setShowLoading(true);
              props.getMissingPegs(orderNumber, type).then(function (response) {
                var _response$loyalty, _response$loyalty$cus;

                setShowLoading(false);

                if (response === null || response === void 0 ? void 0 : (_response$loyalty = response.loyalty) === null || _response$loyalty === void 0 ? void 0 : (_response$loyalty$cus = _response$loyalty.customers) === null || _response$loyalty$cus === void 0 ? void 0 : _response$loyalty$cus.points) {
                  var _response$loyalty2, _response$loyalty2$cu;

                  resetOrderNumberField(formikRef);
                  setShowAwardedModal({
                    show: true,
                    pegs: (response === null || response === void 0 ? void 0 : (_response$loyalty2 = response.loyalty) === null || _response$loyalty2 === void 0 ? void 0 : (_response$loyalty2$cu = _response$loyalty2.customers) === null || _response$loyalty2$cu === void 0 ? void 0 : _response$loyalty2$cu.points) || 0
                  });
                } else {
                  if (!(response === null || response === void 0 ? void 0 : response.success)) {
                    var _response$errorDetail, _response$errorDetail2, _response$errorDetail3, _response$errorDetail4, _response$errorDetail5, _response$errorDetail6, _response$errorDetail7, _response$errorDetail8;

                    if ((response === null || response === void 0 ? void 0 : (_response$errorDetail = response.errorDetails) === null || _response$errorDetail === void 0 ? void 0 : (_response$errorDetail2 = _response$errorDetail[0]) === null || _response$errorDetail2 === void 0 ? void 0 : _response$errorDetail2.reason) === 'Loyalty_Already_Awarded') {
                      resetOrderNumberField(formikRef);
                      setShowPegsPreviouslyRewardedModal(true);
                    } else if ((response === null || response === void 0 ? void 0 : (_response$errorDetail3 = response.errorDetails) === null || _response$errorDetail3 === void 0 ? void 0 : (_response$errorDetail4 = _response$errorDetail3[0]) === null || _response$errorDetail4 === void 0 ? void 0 : _response$errorDetail4.reason) === 'Transaction_Expired') {
                      resetOrderNumberField(formikRef);
                      setShowReceiptExpiredModal(true);
                    } else if ((response === null || response === void 0 ? void 0 : (_response$errorDetail5 = response.errorDetails) === null || _response$errorDetail5 === void 0 ? void 0 : (_response$errorDetail6 = _response$errorDetail5[0]) === null || _response$errorDetail6 === void 0 ? void 0 : _response$errorDetail6.reason) === 'Enrollment_after_transdate') {
                      resetOrderNumberField(formikRef);
                      setShowNoActiveAccountModal(true);
                    } else if ((response === null || response === void 0 ? void 0 : (_response$errorDetail7 = response.errorDetails) === null || _response$errorDetail7 === void 0 ? void 0 : (_response$errorDetail8 = _response$errorDetail7[0]) === null || _response$errorDetail8 === void 0 ? void 0 : _response$errorDetail8.reason) === 'Transaction_Not_Found') {
                      resetOrderNumberField(formikRef);
                      setShowReceiptNotFoundModal(true);
                    } else {
                      setFormikRef(formikRef);
                      setShowLoadingErrorModal(true);
                    }
                  }
                }
              }).catch(function (error) {
                console.error('Error scanning receipt', error);
                setShowLoading(false);
                setFormikRef(formikRef);
                setShowLoadingErrorModal(true);
              });

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleSubmitOrderNumber(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  var handleInStoreClick = function handleInStoreClick(e) {
    var _props$loyalty, _props$loyalty$accoun;

    if (((_props$loyalty = props.loyalty) === null || _props$loyalty === void 0 ? void 0 : (_props$loyalty$accoun = _props$loyalty.account) === null || _props$loyalty$accoun === void 0 ? void 0 : _props$loyalty$accoun.Balance) >= 400) {
      setShow400PegsNoticeModal(true);
    }

    setScreen('inStore');
    setReceiptScreens(true);
  };

  var handleOnlineOrderClick = function handleOnlineOrderClick(e) {
    var _props$loyalty2, _props$loyalty2$accou;

    if (((_props$loyalty2 = props.loyalty) === null || _props$loyalty2 === void 0 ? void 0 : (_props$loyalty2$accou = _props$loyalty2.account) === null || _props$loyalty2$accou === void 0 ? void 0 : _props$loyalty2$accou.Balance) >= 400) {
      setShow400PegsNoticeModal(true);
    }

    setScreen('onlineOrder');
    setReceiptScreens(true);
  };

  var handleShowMissingCreditScreen = function handleShowMissingCreditScreen() {
    setScreen('missingCredit');
    setReceiptScreens(false);
  };

  useEffect(function () {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });

  var MissingCreditHome = function MissingCreditHome(props) {
    var fields = props.fields;
    var Headline = fields.Headline,
        Copy = fields.Copy,
        InStoreCTA = fields.InStoreCTA,
        OnlineOrderCTA = fields.OnlineOrderCTA,
        DisclaimerText = fields.DisclaimerText;
    var flags = useFlags();
    var enableInStoreReceiptScanButton = flags['enableInStoreReceiptScanButton'] ? flags['enableInStoreReceiptScanButton'] : false;
    var enableOnlineOrderReceiptScanButton = flags['enableOnlineOrderReceiptScanButton'] ? flags['enableOnlineOrderReceiptScanButton'] : false;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "cb-account-miss-credit__card"
    }, /*#__PURE__*/React.createElement("div", {
      className: "cb-account-miss-credit__card__header"
    }, /*#__PURE__*/React.createElement(Text, {
      tag: "h3",
      field: {
        value: (Headline === null || Headline === void 0 ? void 0 : Headline.value) || ''
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "cb-account-miss-credit__card__body"
    }, /*#__PURE__*/React.createElement(RichText, {
      className: "cb-account-miss-credit__card__copy",
      field: Copy,
      tag: "div"
    }), /*#__PURE__*/React.createElement("div", {
      className: "cb-account-miss-credit__card__buttons"
    }, enableInStoreReceiptScanButton && /*#__PURE__*/React.createElement(Button, {
      className: "cb-button-primary",
      onClick: handleInStoreClick
    }, (InStoreCTA === null || InStoreCTA === void 0 ? void 0 : InStoreCTA.value) || "In-Store Visit"), enableOnlineOrderReceiptScanButton && /*#__PURE__*/React.createElement(Button, {
      className: "cb-button-primary",
      onClick: handleOnlineOrderClick
    }, (OnlineOrderCTA === null || OnlineOrderCTA === void 0 ? void 0 : OnlineOrderCTA.value) || "Online Order")))), /*#__PURE__*/React.createElement(RichText, {
      className: "cb-account-miss-credit__disclaimer",
      field: DisclaimerText
    }));
  };

  var handleHideAwardedModal = function handleHideAwardedModal() {
    setShowAwardedModal({
      show: false,
      pegs: 0
    });
  };

  var handleRetry = function handleRetry() {
    var _formikRef$current2;

    setShowLoadingErrorModal(false);
    formikRef === null || formikRef === void 0 ? void 0 : (_formikRef$current2 = formikRef.current) === null || _formikRef$current2 === void 0 ? void 0 : _formikRef$current2.handleSubmit();
  };

  var handleHideLoadingErrorModal = function handleHideLoadingErrorModal() {
    resetOrderNumberField(formikRef);
    setShowLoadingErrorModal(false);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "cb-account-miss-credit"
  }, /*#__PURE__*/React.createElement(_400PegsNoticeModalComponent, {
    show: show400PegsNoticeModal,
    hide: function hide() {
      setShow400PegsNoticeModal(false);
    },
    model: (ReceiptScan400PegsNoticeModal === null || ReceiptScan400PegsNoticeModal === void 0 ? void 0 : (_ReceiptScan400PegsNo = ReceiptScan400PegsNoticeModal[0]) === null || _ReceiptScan400PegsNo === void 0 ? void 0 : _ReceiptScan400PegsNo.fields) || {}
  }), /*#__PURE__*/React.createElement(LoadingAnimation, {
    show: showLoading
  }), /*#__PURE__*/React.createElement(LoadingErrorModal, {
    show: showLoadingErrorModal,
    hide: handleHideLoadingErrorModal,
    retry: handleRetry,
    model: (ReceiptScanLoadingAnimation === null || ReceiptScanLoadingAnimation === void 0 ? void 0 : ReceiptScanLoadingAnimation[0].fields) || {}
  }), /*#__PURE__*/React.createElement(PegsAwardedModal, {
    show: showAwardedModal.show,
    hide: handleHideAwardedModal,
    pegs: showAwardedModal.pegs || 0,
    model: (ReceiptScanPegsAwardedModal === null || ReceiptScanPegsAwardedModal === void 0 ? void 0 : (_ReceiptScanPegsAward = ReceiptScanPegsAwardedModal[0]) === null || _ReceiptScanPegsAward === void 0 ? void 0 : _ReceiptScanPegsAward.fields) || {}
  }), /*#__PURE__*/React.createElement(PegsPreviouslyRewardedModalComponent, {
    show: showPegsPreviouslyRewardedModal,
    hide: function hide() {
      setShowPegsPreviouslyRewardedModal(false);
    },
    model: (ReceiptScanPegsPreviouslyRewardedModal === null || ReceiptScanPegsPreviouslyRewardedModal === void 0 ? void 0 : (_ReceiptScanPegsPrevi = ReceiptScanPegsPreviouslyRewardedModal[0]) === null || _ReceiptScanPegsPrevi === void 0 ? void 0 : _ReceiptScanPegsPrevi.fields) || {}
  }), /*#__PURE__*/React.createElement(ReceiptExpiredModal, {
    show: showReceiptExpiredModal,
    hide: function hide() {
      setShowReceiptExpiredModal(false);
    },
    model: (ReceiptScanReceiptExpiredModal === null || ReceiptScanReceiptExpiredModal === void 0 ? void 0 : (_ReceiptScanReceiptEx = ReceiptScanReceiptExpiredModal[0]) === null || _ReceiptScanReceiptEx === void 0 ? void 0 : _ReceiptScanReceiptEx.fields) || {}
  }), /*#__PURE__*/React.createElement(NoActiveAccountModal, {
    show: showNoActiveAccountModal,
    hide: function hide() {
      setShowNoActiveAccountModal(false);
    },
    model: (ReceiptScanLoyaltyAccountNotActiveModal === null || ReceiptScanLoyaltyAccountNotActiveModal === void 0 ? void 0 : (_ReceiptScanLoyaltyAc = ReceiptScanLoyaltyAccountNotActiveModal[0]) === null || _ReceiptScanLoyaltyAc === void 0 ? void 0 : _ReceiptScanLoyaltyAc.fields) || {}
  }), /*#__PURE__*/React.createElement(MissingCreditHeader, {
    model: (Header === null || Header === void 0 ? void 0 : (_Header$ = Header[0]) === null || _Header$ === void 0 ? void 0 : _Header$.fields) || {},
    setShowMissCreditInfo: setShowMissCreditInfo,
    receiptScreens: receiptScreens,
    handleShowMissingCreditScreen: handleShowMissingCreditScreen
  }), /*#__PURE__*/React.createElement(ReceiptScanModal, {
    handleSubmitOrderNumber: handleSubmitOrderNumber,
    show: showReceiptScanModal,
    hide: function hide() {
      setShowReceiptScanModal(false);
    },
    model: (ReceiptScanReceiptScanModal === null || ReceiptScanReceiptScanModal === void 0 ? void 0 : (_ReceiptScanReceiptSc = ReceiptScanReceiptScanModal[0]) === null || _ReceiptScanReceiptSc === void 0 ? void 0 : _ReceiptScanReceiptSc.fields) || {}
  }), /*#__PURE__*/React.createElement(ReceiptNotFoundModal, {
    show: showReceiptNotFoundModal,
    hide: function hide() {
      setShowReceiptNotFoundModal(false);
    },
    model: (ReceiptScanReceiptNotFoundModal === null || ReceiptScanReceiptNotFoundModal === void 0 ? void 0 : (_ReceiptScanReceiptNo = ReceiptScanReceiptNotFoundModal[0]) === null || _ReceiptScanReceiptNo === void 0 ? void 0 : _ReceiptScanReceiptNo.fields) || {}
  }), screen === 'missingCredit' && /*#__PURE__*/React.createElement(MissingCreditHome, props), screen === 'inStore' && /*#__PURE__*/React.createElement(InStoreReceipt, {
    setShowReceiptScanModal: setShowReceiptScanModal,
    handleSubmitOrderNumber: handleSubmitOrderNumber,
    model: (InStoreComponent === null || InStoreComponent === void 0 ? void 0 : (_InStoreComponent$ = InStoreComponent[0]) === null || _InStoreComponent$ === void 0 ? void 0 : _InStoreComponent$.fields) || {}
  }), screen === 'onlineOrder' && /*#__PURE__*/React.createElement(OnlineReceipt, {
    handleSubmitOrderNumber: handleSubmitOrderNumber,
    model: (OnlineOrderComponent === null || OnlineOrderComponent === void 0 ? void 0 : (_OnlineOrderComponent = OnlineOrderComponent[0]) === null || _OnlineOrderComponent === void 0 ? void 0 : _OnlineOrderComponent.fields) || {}
  }));
};

var rewardsOperations = rewardsDuck.operations;

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getMissingPegs: function getMissingPegs(orderNumber, type) {
      return dispatch(rewardsOperations.handleGetMissingPegs(orderNumber, type));
    }
  };
};

export default connect(null, mapDispatchToProps)(MissingCredit);